import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { pick } from 'lodash'
import { withRouter } from 'react-router';
import { Formik, Form } from 'formik';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { getParams } from '../common/utils';
import { hasPermission } from '../../store/apiWrapper';
import { repiSearchFoExactSchema } from './validations/repiSearchFoExactSchema';
import { repiSearchPoExactSchema } from './validations/repiSearchPoExactSchema';
import { repiSearchFoFulltextSchema } from './validations/repiSearchFoFulltextSchema';
import { repiSearchPoFulltextSchema } from './validations/repiSearchPoFulltextSchema';
import { isEmpty, isNullOrUndefined, getRepiSetting } from '../../store/storeFunctions';
import { repiActions, entityTypes, searchTypes, repiSearchFields } from '../../store/repiStore';
import Message from '../common/message';
import SearchTip from '../common/searchTip';
import RepiFooter from './repiFooter';
import BbCollapse from '../common/BbCollapse';
import BbCheckbox from '../styling/bbCheckbox';
import RepiSearchInput from './search/repiSearchInput';

import SearchIcon from '../../img/icons/Search';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';

import '../../css/search/search.scss'
import './repi.scss';

class RepiSearch extends React.Component {
    get isPo() { return this.props.entityType === entityTypes.po; }
    get sharingAllowed() { return getRepiSetting("allowSharing", false); }
    get canPo() { return hasPermission(null, "REPIPO"); }
    get canFo() { return hasPermission(null, "REPIFO"); }
    get canFop() { return hasPermission(null, "REPIFOP"); }

    render() {
        var validRoles = this.validationRoles(this.props.entityType);
        return (
            <div className="repi-search-wrapper">
                <div className="search-content">
                    {!validRoles && <div className="error-container error-container-wide">
                        <Message type="warning" style={{ marginTop: "1em", marginBottom: "1em", width: "95%" }}
                            message={this.props.translate("Monitoring.Overview.Tooltip")}
                        />
                    </div>}
                    <SearchTip windowId="tips_repi_search" className="repi-search-tips" getSearchTipsModel={() => this.getSearchTipsModel()} />
                    <div className="search-container">
                        <Formik enableReinitialize
                            ref={(el) => this.formRef = el}
                            onSubmit={(values) => this.onSubmit(values)}
                            initialValues={this.getInitialValues()}
                            validateOnChange={true}
                            validationSchema={this.getValidationSchema()}
                        >
                            {({ values, errors, touched, setFieldValue, setValues }) =>
                                this.renderSearch({ values, errors, touched, setFieldValue, setValues }, validRoles)}
                        </Formik>
                    </div>
                    <RepiFooter />
                </div>
            </div>
        );
    }

    componentDidMount() {
        const v = this.getSearchParams();
        let entityType = v.entityType;
        if ((isNullOrUndefined(entityType) || entityType === entityTypes.po) && !this.canPo)
            entityType = this.canFo && !this.canFop ? entityTypes.fo : entityTypes.po;

        if (entityType !== entityTypes.po || v.searchType !== searchTypes.exactMatch || v.consent === true
            || v.sharedRegistry === !this.sharingAllowed || v.expandForm === true
        ) {
            this.props.updateSearchParams({
                entityType: entityType,
                searchType: v.searchType,
                consent: v.consent,
                sharedRegistry: v.sharedRegistry,
                formExpanded: v.expandForm
            });
        }
    }

    renderSearch = (formik, validRoles) => {
        const searchEnabled = Object.keys(formik.errors).length === 0 && validRoles;

        return (
            <>
                {this.props.error && <Message type="error" style={{ marginTop: "1em", width: "95%" }}
                    message={this.props.translate("Repi.Error.Search.SearchFailed")}
                />}
                <div className="quick-search-container">
                    <div className="switch">
                        {Object.values(entityTypes).map(e => <div className="btn-wrap" key={e}>
                            <div className={classnames("po-button", {"disabled" : !this.validationRoles(e)})}
                                style={{ fontWeight: this.props.entityType === e ? "600" : "400" }}
                                onClick={() => this.onTabClicked(e, formik.values, formik.setValues)}
                            >
                                {this.props.translate(`Search.Common.${(e === entityTypes.po ? "Company" : "PhysicalPerson")}`)}
                            </div>
                            {this.props.entityType === e && <div className="search-progress-short" />}
                        </div>)}
                    </div>
                    <div className="search-box" >
                        {this.renderQuickSearch(formik)}
                    </div>
                </div>
                <div className="repi-basic-search-form" style={{ width: '100%' }}>
                    <BbCollapse isOpen={this.props.formExpanded}>
                        {this.renderExtendedSearch(formik)}
                    </BbCollapse>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div className="basic-search-link" style={{ position: "relative", top: "2px" }}
                        onClick={() => this.props.updateSearchParams({ formExpanded: !this.props.formExpanded })}
                    >
                        <div className="basic-search-link-label">
                            <Translate id={this.props.formExpanded ? "Search.BasicSearch.SectionName" : "Search.Advanced.Search"} />&nbsp;
                            <AngleDownIcon icon="angle-down" className="svg-standard-fill"
                                style={{ transform: `scaleY(${this.props.formExpanded ? -1 : 1})` }} />
                        </div>
                    </div>
                </div>
                {!getRepiSetting("negativeDataOnly", true) && <div className="columns m-0 repi-search-consent-wrapper">
                    <BbCheckbox label={this.props.translate("Repi.Search.Consent")}
                        id="consent" value={this.props.consent}
                        onChange={(value) => this.props.updateSearchParams({ consent: value })}
                    />
                </div>}
                <div className="columns m-0">
                    <div className="column" style={{
                        textAlign: "center", padding: "1em", marginBottom: "1em", display: "flex", flexBasis: "auto",
                        flexWrap: "wrap", justifyContent: "center"
                    }}
                    >
                        <button onClick={() => document.querySelector("#fake-submit").click()} style={{ fontWeight: 600 }} disabled={!searchEnabled}
                            className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        >
                            <Translate id="Search.Common.Search" />
                        </button>
                    </div>
                </div>
            </>
        )
    }

    renderQuickSearch = (formik) => {
        return (
            <div className="search-inputs">
                <div className="control-row">
                    <div className="control search-name">
                        <div style={{ display: "flex", alignItems: 'center' }}>
                            <span className='with-pointer'>
                                <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' />
                            </span>
                            <input type="text" autoComplete="on"
                                defaultValue={this.isPo ? formik.values[repiSearchFields.companyId] : formik.values[repiSearchFields.pin]}
                                placeholder={this.props.translate(this.isPo ? "Repi.Search.CompanyId" : "Repi.Search.Pin")}
                                className="ellipsis search-input"
                                onKeyUp={e => this.onInputChanged(e, this.isPo ? repiSearchFields.companyId : repiSearchFields.pin, formik.setFieldValue)}
                                onKeyDown={this.submitSearchByKey}
                            />
                        </div>
                        <div className="search-progress" />
                    </div>
                    <div className="control search-dob" style={{ borderBottom: "1px solid #dbdbdb" }}>
                        <select className="ellipsis search-input" style={{ paddingLeft: "0" }} defaultValue={formik.values[repiSearchFields.country]}
                            onChange={e => formik.setFieldValue(repiSearchFields.country, e.target.value)}
                        >
                            <option value="" disabled hidden>{this.props.translate("Repi.Search.Country")}</option>
                            <option value="CZ">{this.props.translate("Repi.Search.Country.CZ")}</option>
                            <option value="SK">{this.props.translate("Repi.Search.Country.SK")}</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    renderExtendedSearch = (formik) => {
        return (
            <Form id="search-form">
                {this.isPo ? this.renderPoExtendedSearch(formik) : this.renderFoExtendedSearch(formik)}
                {this.renderSearchById(formik)}
                <div style={{ display: "none" }}>
                    <input type="submit" id="fake-submit"></input>
                </div>
            </Form>
        );
    }

    renderPoExtendedSearch = (formik) => {
        return (
            <>
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.companyName} label={this.props.translate("Repi.Search.CompanyName")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.phone} label={this.props.translate("Repi.Search.Phone")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.email} label={this.props.translate("Repi.Search.Email")} formik={formik} />
                </div>
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.city} label={this.props.translate("Repi.Search.City")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.zip} label={this.props.translate("Repi.Search.Zip")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.street} label={this.props.translate("Repi.Search.Street")} formik={formik} />
                </div>
            </>
        );
    }

    renderFoExtendedSearch = (formik) => {
        return (
            <>
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.name} label={this.props.translate("Repi.Search.Name")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.surname} label={this.props.translate("Repi.Search.Surname")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.birthDate} label={this.props.translate("Repi.Search.BirthDate")} formik={formik}
                        isDate formRef={this.formRef} />
                </div>
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.city} label={this.props.translate("Repi.Search.City")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.zip} label={this.props.translate("Repi.Search.Zip")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.street} label={this.props.translate("Repi.Search.Street")} formik={formik} />
                </div>
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.houseNo} label={this.props.translate("Repi.Search.HouseNo")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.phone} label={this.props.translate("Repi.Search.Phone")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.email} label={this.props.translate("Repi.Search.Email")} formik={formik} />
                </div>
                {this.canFop && <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.companyIdFop} label={this.props.translate("Repi.Search.CompanyId")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.companyName} label={this.props.translate("Repi.Search.CompanyName")} formik={formik} />
                    <div className="repi-search-flex" />
                </div>}
            </>
        );
    }

    renderSearchById = (formik) => {
        const dcContributor = hasPermission(null, "REPIDataCorrectionContributor");
        const dcInternal = hasPermission(null, "REPIDataCorrectionInternal");
    
        if (!dcContributor && !dcInternal)
            return null;

        return (
            <>
                <hr />
                <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.candidateId} label={this.props.translate("Repi.Search.CandidateId")} formik={formik} />
                    {dcInternal
                        ? <RepiSearchInput name={repiSearchFields.subjectId} label={this.props.translate("Repi.Search.SubjectId")} formik={formik} />
                        : <div className="repi-search-flex" />}
                    <div className="repi-search-flex" />
                </div>
                {dcInternal && <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.contributorId} label={this.props.translate("Repi.Other.ContributorId")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.contributorSubjectId} label={this.props.translate("Repi.Other.ContributorSubjectId")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.contributorContractId} label={this.props.translate("Repi.Other.ContributorContractId")} formik={formik} />
                </div>}
                {dcContributor && !dcInternal && <div className="columns is-multiline is-centered m-0">
                    <RepiSearchInput name={repiSearchFields.contributorSubjectId} label={this.props.translate("Repi.Other.ContributorSubjectId")} formik={formik} />
                    <RepiSearchInput name={repiSearchFields.contributorContractId} label={this.props.translate("Repi.Other.ContributorContractId")} formik={formik} />
                    <div className="repi-search-flex" />
                </div>}
            </>
        );
    }

    getInitialValues() {
        const values = this.getSearchParams();

        return {
            [repiSearchFields.name]: this.getInitialValue(values, repiSearchFields.name),
            [repiSearchFields.surname]: this.getInitialValue(values, repiSearchFields.surname),
            [repiSearchFields.pin]: this.getInitialValue(values, repiSearchFields.pin),
            [repiSearchFields.companyId]: this.getInitialValue(values, repiSearchFields.companyId),
            [repiSearchFields.birthDate]: this.getInitialValue(values, repiSearchFields.birthDate),
            [repiSearchFields.city]: this.getInitialValue(values, repiSearchFields.city),
            [repiSearchFields.street]: this.getInitialValue(values, repiSearchFields.street),
            [repiSearchFields.zip]: this.getInitialValue(values, repiSearchFields.zip),
            [repiSearchFields.houseNo]: this.getInitialValue(values, repiSearchFields.houseNo),
            [repiSearchFields.companyName]: this.getInitialValue(values, repiSearchFields.companyName),
            [repiSearchFields.phone]: this.getInitialValue(values, repiSearchFields.phone),
            [repiSearchFields.email]: this.getInitialValue(values, repiSearchFields.email),
            [repiSearchFields.country]: this.getInitialValue(values, repiSearchFields.country),
            [repiSearchFields.candidateId]: this.getInitialValue(values, repiSearchFields.candidateId),
            [repiSearchFields.subjectId]: this.getInitialValue(values, repiSearchFields.subjectId),
            [repiSearchFields.contributorId]: this.getInitialValue(values, repiSearchFields.contributorId),
            [repiSearchFields.contributorSubjectId]: this.getInitialValue(values, repiSearchFields.contributorSubjectId),
            [repiSearchFields.contributorContractId]: this.getInitialValue(values, repiSearchFields.contributorContractId),
            [repiSearchFields.companyIdFop]: this.getInitialValue(values, repiSearchFields.companyIdFop)
        };
    }

    getSearchTipsModel = () => {
        return {
            title: this.props.translate("Repi.Search.Tips.Header"),
            bodyHtml: this.props.translate("Repi.Search.Tips.Body")
        }
    }

    onTabClicked = (e, values, setValues) => {
        if (this.props.entityType !== e) {
            if (e === entityTypes.fo) {
                if (this.canFop) {
                    setValues({
                        ...values,
                        [repiSearchFields.companyId]: "",
                    });
                } else {
                setValues({
                        ...values,
                        [repiSearchFields.companyId]: "",
                        [repiSearchFields.companyName]: "",
                    });
                }
            } else {
                setValues({
                    ...values,
                    [repiSearchFields.pin]: "",
                    [repiSearchFields.name]: "",
                    [repiSearchFields.surname]: "",
                    [repiSearchFields.birthDate]: "",
                    [repiSearchFields.houseNumber]: "",
                    [repiSearchFields.companyIdFop]: "",
                });
            }
        }

        this.props.updateSearchParams({ entityType: e });
    }

    onInputChanged = (event, field, setFieldValue) => {
        if (!isNullOrUndefined(event) && !isNullOrUndefined(event.target) && !isNullOrUndefined(event.target.value))
            setFieldValue(field, event.target.value.trim())
    }

    onSubmit = (values) => {
        const searchParams = {
            searchType: this.props.searchType === searchTypes.exactMatch ? "em" : "ft",
            entityType: this.props.entityType === entityTypes.fo ? "fo" : "po",
            sharedRegistry: this.sharingAllowed ? this.props.sharedRegistry === true : false
        };

        if (this.props.consent === true)
            searchParams.consent = true

        Object.keys(values).forEach(k => {
            if (k === repiSearchFields.pin && !isEmpty(values[k]))
                searchParams[k] = encodeURIComponent(values[k].replace("/", ""));
            else if (!isEmpty(values[k]))
                searchParams[k] = encodeURIComponent(values[k]);
        });

        this.props.repiRedirect(`/results?${new URLSearchParams(searchParams).toString()}`);
    }

    submitSearchByKey = (event) => {
        if (!isNullOrUndefined(event) && !isNullOrUndefined(event.target) && !isNullOrUndefined(event.target.value) && event.key === "Enter")
            document.querySelector("[type=submit]").click();
    }

    validationRoles = (entityType) => {
        switch (entityType) {
            case entityTypes.po:
                return this.canPo || this.canFop;
            case entityTypes.fo:
                return this.canFo;
            default:
                return false;
        }
    }

    getValidationSchema = () => {
        const tr = this.props.translate;
        const dcContributor = hasPermission(null, "REPIDataCorrectionContributor");
        const dcInternal = hasPermission(null, "REPIDataCorrectionInternal");
        
        if (this.props.searchType === searchTypes.fullText) {
            return this.props.entityType === entityTypes.fo
                ? repiSearchFoFulltextSchema(tr, dcContributor, dcInternal)
                : repiSearchPoFulltextSchema(tr, dcContributor, dcInternal);
        } else {
            return this.props.entityType === entityTypes.fo
                ? repiSearchFoExactSchema(tr, dcContributor, dcInternal)
                : repiSearchPoExactSchema(tr, dcContributor, dcInternal);
        }
    }

    getSearchParams = () => {
        const fromQuery = getParams(window.location.search);
        const searchInputs = pick(fromQuery, Object.values(repiSearchFields))

        const params = {};
        Object.values(repiSearchFields).forEach(k => params[k] = "");
        Object.keys(searchInputs).forEach(k => params[k] = searchInputs[k]);

        params.country = ["CZ", "SK"].includes(fromQuery.country) ? fromQuery.country : "CZ"
        params.searchType = fromQuery.searchType === "em" ? searchTypes.exactMatch : searchTypes.fullText;
        params.consent = fromQuery.consent === "true";
        params.sharedRegistry = isNullOrUndefined(fromQuery.sharedRegistry)
            ? this.sharingAllowed
            : this.sharingAllowed && fromQuery.sharedRegistry === "true";

        if (isNullOrUndefined(fromQuery.entityType) && (this.canFo && !(this.canFop || !this.canPo)))
            params.entityType = entityTypes.fo;
        else
            params.entityType = fromQuery.entityType === "fo" ? entityTypes.fo : entityTypes.po;

        params.expandForm = Object.values(repiSearchFields)
            .filter(f => f !== repiSearchFields.pin && f !== repiSearchFields.companyId && f !== repiSearchFields.country)
            .map(x => !isNullOrUndefined(params[x]) && params[x] !== "")
            .reduce((a, c) => a || c, false)

        return params;
    }

    getInitialValue = (values, field) =>
        isNullOrUndefined(values) || isNullOrUndefined(values[field]) ? "" : values[field];
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.repi.search }),
    dispatch => bindActionCreators(repiActions, dispatch),
)(RepiSearch)));
